import React from 'react';

import classNames from '../../../utils/classNames';

export type FramedSectionVisual = {
  wrapperClass: string;
  accentBarClass: string;
  iconClass: string;
  icon: React.ReactNode;
  badgeClass: string;
  badgeIcon: React.ReactNode;
  badgeLabel: string;
  subtitleClass?: string;
};

export type FramedSectionProps = {
  title: string;
  subtitle: string;
  visual: FramedSectionVisual;
  children: React.ReactNode;
};

function FramedSection({ title, subtitle, visual, children }: FramedSectionProps) {
  return (
    <section className={classNames('relative rounded-2xl border pl-1 shadow-sm', visual.wrapperClass)}>
      <div
        className={classNames('absolute top-0 left-0 h-full w-1 rounded-l-2xl', visual.accentBarClass)}
        aria-hidden="true"
      />
      <div className="px-5 py-5 sm:px-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="flex min-w-0 items-start gap-3">
            <div
              className={classNames(
                'mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg',
                visual.iconClass,
              )}
            >
              {visual.icon}
            </div>
            <div className="min-w-0">
              <h3 className="text-lg font-bold text-slate-800">{title}</h3>
              <p className={classNames('text-[13px] font-medium', visual.subtitleClass ?? 'text-slate-500')}>
                {subtitle}
              </p>
            </div>
          </div>
          <span
            className={classNames(
              'inline-flex shrink-0 items-center gap-1 rounded-full px-3 py-1 text-[10.5px] font-bold tracking-wide',
              visual.badgeClass,
            )}
          >
            {visual.badgeIcon}
            {visual.badgeLabel}
          </span>
        </div>

        <div className="mt-5">
          {children}
        </div>
      </div>
    </section>
  );
}

export default FramedSection;
